/**
 * Auto-format helpers for form inputs.
 */

/**
 * Convert a free-text name/label into Title Case *only if* the user typed
 * everything in lowercase (or all uppercase). If the input already has mixed
 * case — e.g. "IBM", "iPhone", "M/s Tata" — return it unchanged so the user's
 * intentional capitalisation is preserved.
 *
 * Examples:
 *   "tata consumer"     → "Tata Consumer"
 *   "TATA CONSUMER"     → "Tata Consumer"
 *   "Tata Consumer"     → "Tata Consumer"   (unchanged, already mixed)
 *   "IBM"               → "IBM"             (unchanged, has uppercase)
 *   "  hello   world "  → "Hello   World"   (spacing preserved, trimmed ends)
 */
export function toSmartTitleCase(input) {
  if (input == null) return input;
  const s = String(input).trim();
  if (!s) return "";
  const hasUpper = /[A-Z]/.test(s);
  const hasLower = /[a-z]/.test(s);
  // Already mixed case (e.g. "iPhone", "VP of R&D", "M/s Tata"): respect user intent.
  if (hasUpper && hasLower) return input;
  // Short single-token all-caps input looks like an acronym (IBM, HP, HUL, GSK,
  // ONGC, ITC, TCS…). Preserve it. Length 5+ would collide with common names
  // typed in caps (e.g. "RAMESH") which we still want to Title-Case.
  if (hasUpper && !hasLower && !/\s/.test(s) && s.length <= 4) return input;
  // Otherwise Title-Case each whitespace-separated word.
  return s
    .toLowerCase()
    .replace(/\b([a-z])/g, (m) => m.toUpperCase());
}
